<template lang="pug">
.wrapper-gerenciamento-de-arquivo-detalhes-listagem
  DBLabel(title="descricao:" :body="item.descricao" :loading="loading")
  .pedido
    DBLabel(title="pedido:" :body="item.mensagemDeAprovacao" :loading="loading")
  DBLabel(title="categoria:" :body="item.motivo.description" :loading="loading")
  DBLabel(title="status:" :body="funcaoDeTextoDaSituacao(item)" :loading="loading")
  DBLabel(title="data de upload:" :body="dateParaString(item.dataDeCriacaoPedidoUtc)" :loading="loading")
  DBLabel(title="criado por:" :body="formataUsuarioComEmail(item.usuarioQueCriou)" :loading="loading")
  .prazo
    DBLabel(title="prazo para resposta por colaboradores:" :body="dateParaString(item.dataLimitePedidoUtc)" :loading="loading")

  .resposta-dos-usuarios(v-if="!ehFuncionario")
    template(v-if="!loading")
      label resposta dos usuários:
      .infos
        .info-de-visualizacao(v-for="(pedido, index) in item.situacaoPedidosIndividuais")
          .icone
            .fs-19.icon-ptt-icons-aprovar.color-success(v-if="pedido.situacao === 'aprovado'" title="aprovado")
            .fs-19.icon-ptt-icons-reprovar.color-danger(v-else-if="pedido.situacao === 'rejeitado'" title="rejeitado")
            .fs-19.icon-ptt-icons-alerta.color-warning(v-else)
          .texto(:style="corDaBorda(pedido)")
            .horario-e-data(v-if="pedido.dataDeAlteracaoDaSituacao") {{ datetimeParaString(pedido.dataDeAlteracaoDaSituacao) }}
            .nome-e-email {{ formataUsuarioComEmail(pedido.usuarioQueAprovaraId) }}
            .justificativa(v-if="pedido.justificativa !== ''") {{ pedido.justificativa }}
            .pseudolink(
              v-if="pedido.situacao === 'aprovado' || pedido.situacao === 'rejeitado'"
              @click="abreModalDeInfo(index)"
            )
              | ver informacoes adicionais
  .botoes
    a.link-escondido(:href="item.arquivo" download target="_blank" ref="download")
    PButton(color="info" size="md" @click="baixar(item)" title="baixar" :disabled="loading || carregandoArquivar")
      .icon-ptt-icons-baixo
    PButton(
      v-if="item.podeSerArquivado && temPermissaoDeExcluir"
      color="warning"
      size="md"
      title="arquivar"
      :disabled="loading"
      :loading="carregandoArquivar"
      @click="arquivar(item)"
    )
      | arquivar
    PButton(
      v-if="usuarioLogadoPrecisaAprovar && item.situacao === 'pendente'"
      color="warning"
      size="md"
      title="ir para visualização"
      :disabled="loading || carregandoArquivar"
      @click="irParaAprovacao(item)"
    )
      | ver e aceitar arquivo

  PModal(name="modalDeInformacoesAdicionais" height="586px" width="604px")
    .wrapper-modal-de-informacoes-adicionais
      .resposta
        .titulo resposta:
        .texto {{ mensagemDeSituacao(pedidoNoModal.situacao) }}
      .respondido-por
        .titulo respondido por:
        .texto {{ formataUsuarioComEmail(pedidoNoModal.usuarioQueAprovaraId) }}
      .data
        .titulo data e horario:
        .texto {{ datetimeParaString(pedidoNoModal.dataDeAlteracaoDaSituacao) }}
      .ip
        .titulo endereço ip:
        .texto {{ formataIp(pedidoNoModal.enderecoIp) }}
      .geolocalizacao
        .titulo geolocalizacao (localização aproximada):
        .mapa
          GmapMap(
            :center="centralizacaoPosicao(pedidoNoModal.localizacao)"
            :zoom="pedidoNoModal.localizacao ? 17 : 5"
            map-type-id="terrain"
            style="width: 100%; height: 370px"
            :options="{disableDefaultUI: true}"
          )
            GmapMarker(
              v-if="pedidoNoModal.localizacao"
              :position="{lat: Number(pedidoNoModal.localizacao.latitude), lng: Number(pedidoNoModal.localizacao.longitude)}"
              :draggable="false"
            )
</template>

<script>
import moment from 'moment'

export default {
  name: 'Details',
  props: {
    item: {type: Object, required: true},
    loading: {type: Boolean, required: true},
    funcaoDeTextoDaSituacao: {type: Function, required: true}
  },
  data () {
    return {
      carregandoArquivar: false,
      indexDaSituacaoNoModal: undefined,
      mapa: {
        show: true,
        place: null,
        zoom: 5,
        center: {lat: -23.5505199, lng: -46.63330940000003},
        marker: {}
      }
    }
  },
  computed: {
    ehFuncionario () {
      return this.$store.state.userInfo.roleGroup.kind === 'mine'
    },
    usuarioLogadoPrecisaAprovar () {
      if (!this.item) return false

      const { situacaoPedidosIndividuais } = this.item
      const pedidoDoUsuarioLogado = situacaoPedidosIndividuais.find(pedido => {
        return pedido.usuarioQueAprovaraId.id === this.$store.state.userInfo.id
      })

      return pedidoDoUsuarioLogado && pedidoDoUsuarioLogado.situacao === 'pendente'
    },
    pedidoNoModal () {
      if (typeof this.indexDaSituacaoNoModal === 'undefined') {
        return {
          usuarioVinculado: undefined,
          situacao: undefined,
          dataDeAlteracaoDaSituacao: undefined
        }
      }
      return this.item.situacaoPedidosIndividuais[this.indexDaSituacaoNoModal]
    },
    temPermissaoDeExcluir () {
      return this.$hasPermission({module: 'aprovacaoarquivo', action: 'delete'})
    }
  },
  methods: {
    dateParaString (date) {
      if (!date) return '-'
      const data = moment(date, 'YYYY-MM-DD')
      return data.format('DD.MM.YYYY')
    },
    formataUsuarioComEmail (usuario) {
      if (this.loading) return ''
      if (!usuario) return '-'

      const { name, email } = usuario

      if (email.includes('lar21@')) return 'Sistema'

      return `${name} (${email})`
    },
    baixar (item) {
      this.$refs.download.click()
    },
    async arquivar (item) {
      this.carregandoArquivar = true
      try {
        await this.$API.gerenciamentoDeArquivos.update({ id: this.item.id }, {})

        this.$emit('updateTable', true)
        this.$modalDeSucesso('Documento arquivado com sucesso!')
      } catch (e) {
        console.error(e)
        this.$modalDeErro(e?.data?.error ? e.data.error : `Não foi possível arquivar.`)
      } finally {
        this.carregandoArquivar = false
      }
    },
    irParaAprovacao (item) {
      this.$router.push(`/gerenciamento-de-arquivos/aprovacao/${item.id}`)
    },
    corDaBorda (pedido) {
      if (pedido.situacao === 'aprovado') return 'border-left-color: var(--color-success)'
      else if (pedido.situacao === 'rejeitado') return 'border-left-color: var(--color-danger)'

      return 'border-left-color: var(--color-warning)'
    },
    datetimeParaString (datetime) {
      if (!datetime) return '-'
      const data = moment.utc(datetime, 'YYYY-MM-DDTHH:mm:ss')
      const dataLocal = moment(data).local()
      return dataLocal.format('HH:mm | DD.MM.YYYY')
    },
    abreModalDeInfo (index) {
      this.indexDaSituacaoNoModal = index
      this.$modal.show('modalDeInformacoesAdicionais')
    },
    mensagemDeSituacao (situacao) {
      if (situacao === 'aprovado') {
        return 'documento aprovado'
      } else if (situacao === 'rejeitado') {
        return 'documento reprovado'
      } else if (situacao === 'pendente') {
        return 'ainda pendente'
      }

      return '-'
    },
    formataIp (ip) {
      if (!ip) return '-'
      return ip
    },
    centralizacaoPosicao (posicao) {
      if (!posicao) return {lat: -23.5505199, lng: -46.63330940000003}
      return {lat: Number(posicao.latitude), lng: Number(posicao.longitude)}
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper-gerenciamento-de-arquivo-detalhes-listagem {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-row-gap: 30px;

  .descricao, .pedido, .prazo {
    grid-column: 1/3;
  }

  .resposta-dos-usuarios {
    grid-column: 1/3;

    label {
      display: block;
      font-size: 15px;
      margin-bottom: 10px;
    }
    .infos {
      overflow-y: scroll;
      max-height: 120px;

      .info-de-visualizacao {
        margin-bottom: 15px;

        display: grid;
        grid-auto-flow: column;
        grid-template-columns: min-content auto;

        .icone {
          place-self: center;
          padding: 0 12px;
        }
        .texto {
          padding-left: 10px;
          border-left-width: 2px;
          border-left-style: solid;

          .pseudolink {
            font-size: 16px;
            color: var(--color-info);
            cursor: pointer;
            margin-right: 20px;
          }
        }
      }
    }

  }

  .botoes {
    grid-column: 1/3;
    margin-top: 10px;
    justify-self: right;
    align-self: end;

    display: grid;
    grid-gap: 1px;
    grid-auto-flow: column;

    .link-escondido {
      display: none;
    }
  }

  .wrapper-modal-de-informacoes-adicionais {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-row-gap: 10px;

    .resposta, .respondido-por, .geolocalizacao {
      grid-column: 1/3;
    }

    .titulo {
      font-size: 13px;
      margin-bottom: 3px;
    }
    .texto {
      font-size: 16px;
      line-height: 21px;
    }
  }
}
</style>
